import React, { useRef, useState } from "react";
import contact from "../assets/contactus.jpg";
import "../css/contactForm.css";
import translations from "../resources/translations";
import axios from "axios";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";

 function ContactForm({ setLanguage }) {
  const currentLanguage = translations[setLanguage] || translations["mr"]; // Default to 'en' if language is not found
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const url = process.env.REACT_APP_BASE_URL; 
  const recaptchaRef = useRef(null);  // Add this ref
  const [captchaToken, setCaptchaToken] = useState(null); 
  const [captchaStatus,setCaptchaStaus] = useState(null);

  const CaptchaSiteKey = process.env.REACT_APP_CAPTCHA_SITEKEY;


  const handleCaptcha = (token) => {
    setCaptchaToken(token);
    setCaptchaStaus(null); // Reset status on new verification
  };


  

  const validateForm = () => {
    let errors = {};
    let isValid = true;
  
    if (!formData.name.trim()) {
      errors.name = "कृपया आपले नाव लिहा";
      isValid = false;
    }
  
    if (!formData.email.trim()) {
      errors.email = "कृपया आपला ईमेल लिहा";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "कृपया आपला योग्य ईमेल लिहा";
      isValid = false;
    }
  
    if (/^\d{10}$/.test(formData.subject)) {
      // Valid subject (exactly 10 numeric characters)
      errors.subject = "";
    } else {
      // Invalid subject
      errors.subject = "कृपया आपला योग्य नंबर लिहा ";
      isValid = false;
    }
  
    if (!formData.message.trim()) {
      errors.message = "कृपया संदेश लिहा";
      isValid = false;
    }
  
      
    if (!captchaToken) {
      errors.captchaToken = "CAPTCHA is required";
      isValid = false;
    }
  
    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!captchaToken) {
      setErrors(prev => ({...prev, captchaToken: "Please complete the CAPTCHA"}));
      return;
    }

    if (validateForm()) {
      try {
        const response = await axios.post(`${url}/api/contacts/add`, {...formData,token:captchaToken}  , {
          headers: {
            "Content-Type": "application/json",
          },
        });

        // Reset form after successful submission
        setFormData({ name: "", email: "", subject: "", message: "" });
        setCaptchaToken(null);
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();  // Reset CAPTCHA
        }
        toast.success("आपला संदेश पाठवला आहे...");
        setCaptchaStaus(response.data.success?.message);
      } catch (error) {
        // Handling errors
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();  // Reset on error
        }
        setCaptchaToken(null);
        const errorMessage = error.response?.data?.message || "Submission failed. Please try again.";
        toast.error(errorMessage);
      }
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };
  return (
    <>
      {/* <!-- Contact Start --> */}
      <div className="contact">
        <div className="container">
          <div className="section-header text-center"></div>
          <div className="contact-img">
            <img src={contact} alt="/assets/contactus" />
          </div>
          <div className="contact-form">
            <div className="sent text-success" id="success"></div>
            <form
              name="sentMessage"
              id="contactForm"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="control-group">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder={currentLanguage.contactForm?.name}
                  value={formData.name}
                  onChange={handleChange}
                  autoComplete="name"
                  required
                />
                <p className="text-danger">{errors.name}</p>
              </div>
              <div className="control-group">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder={currentLanguage.contactForm?.email}
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                  required
                />
                <p className="text-danger">{errors.email}</p>
              </div>
              <div className="control-group">
                <input
                  type="text"
                  maxlength="10"
                  pattern="^[0-9]{10}$"
                  className="form-control"
                  id="subject"
                  placeholder={currentLanguage.contactForm?.subject}
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  onInput={(e) => {
                    // Allow only digits (numbers)
                    e.target.value = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 10);
                  }}
                />
                <p className="text-danger">{errors.subject}</p>
              </div>
              <div className="control-group">
                <textarea
                  className="form-control"
                  id="message"
                  placeholder={currentLanguage.contactForm?.message}
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
                <p className="text-danger">{errors.message}</p>
              </div>

              {/*  the captcha is here   */}
              <div className="control-group">
               
             <ReCAPTCHA  ref={recaptchaRef} sitekey={CaptchaSiteKey} onChange={handleCaptcha}  onExpired={() => setCaptchaToken(null)}/>
              <p className="text-danger">{  errors.captchaToken}</p>
             {captchaStatus && <p>{captchaStatus}</p>}
                
              </div>
              <div>
                <button
                  className="btn btn-custom"
                  type="submit"
                  id="sendMessageButton"
                >
                  {currentLanguage.contactForm?.submit}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <!-- Contact End --> */}
    </>
  );
}

export default ContactForm;
